/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from "../../../Styles/dashboard.module.css";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { urlEnum } from "../../../Utils/UrlEnum";
import MainTable from "../../GenericComponents/MainTable";
import { useContext, useState } from "react";
import { ImportExcelDescription, TypeModel } from "../../../Utils/Models";
import { updateData } from "../../../Services/updateData";
import { postData } from "../../../Services/postData";
import { CacheWebsocketContext } from "../../../Contexts/WebsocketContext";
import { styleForTableWithTabs } from "../../../Pages/Users";
import ImportExcelButton from "../../GenericComponents/ImportExcelButton";
import ImportExcelModal from "../../GenericComponents/ImportExcelModal";
import Type from "./Type";

export default function Types() {
  const websocketContext = useContext(CacheWebsocketContext);
  const [open, setOpen] = useState(false);
  const [openImportExcel, setOpenImportExcel] = useState(false);
  const [editItem, setEditItem] = useState<TypeModel | null>(null);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  /**
   *
   */
  const description: Array<ImportExcelDescription> = [
    {
      name: "Name",
      description: Vocabulary.itemName,
      example: "Materie prima",
    },
    {
      name: "Description",
      description: Vocabulary.itemDescription,
      example: "Descrierea materiei prime",
    },
  ];
  /**
   *
   */
  const typeHeader = [
    { label: Vocabulary.name, name: "name", options: { sort: false } },
    {
      label: Vocabulary.description,
      name: "description",
      options: { sort: false },
    },
  ];
  /**
   *
   * @param item
   */
  function handleEdit(item: TypeModel | null) {
    setShouldUpdate(false);
    setOpen(!open);
    setEditItem(item);
  }
  /**
   *
   * @param type
   */
  function addOrUpdateType(type: TypeModel | null) {
    if (type?._id) {
      updateData(`${urlEnum.types}/${type._id}`, type)
        .then((res) => {
          if (res) {
            websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
            setShouldUpdate(true);
            setOpen(false);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    } else {
      postData(urlEnum.types, type)
        .then((res: any) => {
          if (res) {
            websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
            setShouldUpdate(true);
            setOpen(false);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    }
  }
  /**
   *
   * @param items
   */
  async function saveToDatabase(items: any) {
    const res = await postData(`${urlEnum.types}/insertMany`, items);
    if (res && res.data && res.data.result) {
      setOpenImportExcel(false);
      websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
      setShouldUpdate(true);
    }
  }

  return (
    <div className={styles.mainContainerUser}>
      <MainTable
        urlEnumApi={urlEnum.types}
        header={typeHeader}
        tableTitle={Vocabulary.typesList}
        deleteMessages={{
          title: Vocabulary.deleteType,
          text: Vocabulary.deleteConfirmationType,
        }}
        shouldUpdate={shouldUpdate}
        handleEdit={handleEdit}
        customStyle={{
          tableStyle: styleForTableWithTabs,
        }}
        headerButtons={
          <ImportExcelButton
            onClickImportButton={() => {
              setOpenImportExcel(true);
              setShouldUpdate(false);
            }}
          />
        }
      />
      {open ? (
        <Type
          editType={editItem}
          open={open}
          addOrUpdateType={(type: TypeModel | null) => addOrUpdateType(type)}
          onClose={() => handleEdit(null)}
        />
      ) : null}
      {openImportExcel ? (
        <ImportExcelModal
          open={openImportExcel}
          onClose={() => setOpenImportExcel(false)}
          saveItems={(items: any) => saveToDatabase(items)}
          description={description}
        />
      ) : null}
    </div>
  );
}


export type ContractData = {
  contractDate: string;
  providerCompany: string;
  providerAddress: string;
  providerCUI: string;
  providerJ: string;
  providerRepresentative: string;
  clientName: string;
  clientAddress: string;
  clientCNP: string;
};
